import React, { useState } from 'react';
import { connectIntegration, disconnectIntegration, saveIntegrationSettings } from '../../lib/integrations';

export default function ConnectionAccount({ provider, connection, onChange, disabled = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!connection) return null;
  const label = provider === 'jira' ? 'Jira' : 'Slack';
  const run = async work => {
    setBusy(true); setError('');
    try { await work(); await onChange?.(); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <div className="v2-panel">
    <p><strong>{connection.account?.name || connection.account?.id || 'Previously connected account'}</strong>{connection.account?.email && <><br/>{connection.account.email}</>}</p>
    {!connection.account && <p>Reconnect to verify which account is linked.</p>}
    <p className="v2-muted">Connected to your SPCC account. Choose another account in the provider window to switch.</p>
    <div className="v2-actions">
      <button type="button" className="v2-button secondary" disabled={disabled || busy} onClick={() => run(async () => {
        await connectIntegration(provider);
        await saveIntegrationSettings(provider, provider === 'jira' ? { projects: [] } : { channel: '', realtimeSync: false });
      })}>{busy ? 'Working…' : `Switch ${label} account`}</button>
      <button type="button" className="v2-button secondary" disabled={disabled || busy} onClick={() => run(() => disconnectIntegration(provider))}>Disconnect {label}</button>
    </div>
    {error && <p role="alert" className="v2-error">{error}</p>}
  </div>;
}
